import * as tslib_1 from "tslib";
import { URLLoader as URLLoaderAway, URLLoaderEvent } from "@awayjs/core";
import { EventDispatcher } from "../events/EventDispatcher";
import { Event } from "../events/Event";
import { ProgressEvent } from "../events/ProgressEvent";
var URLLoader = (function (_super) {
    tslib_1.__extends(URLLoader, _super);
    function URLLoader() {
        var _this = _super.call(this) || this;
        _this._adaptee = new URLLoaderAway();
        _this._completeCallbackDelegate = function (event) { return _this.completeCallback(event); };
        _this._progressCallbackDelegate = function (event) { return _this.progressCallback(event); };
        _this.eventMapping[Event.COMPLETE] = {
            adaptedType: URLLoaderEvent.LOAD_COMPLETE,
            addListener: _this.initListener,
            removeListener: _this.removeListener,
            callback: _this._completeCallbackDelegate
        };
        _this.eventMapping[ProgressEvent.PROGRESS] = {
            adaptedType: URLLoaderEvent.LOAD_PROGRESS,
            addListener: _this.initListener,
            removeListener: _this.removeListener,
            callback: _this._progressCallbackDelegate
        };
        return _this;
    }
    Object.defineProperty(URLLoader.prototype, "data", {
        get: function () {
            return this._adaptee.data;
        },
        enumerable: true,
        configurable: true
    });
    URLLoader.prototype.initListener = function (type, callback) {
        this._adaptee.addEventListener(type, callback);
    };
    URLLoader.prototype.removeListener = function (type, callback) {
        this._adaptee.removeEventListener(type, callback);
    };
    URLLoader.prototype.progressCallback = function (event) {
        if (event === void 0) { event = null; }
        var newEvent = new ProgressEvent(ProgressEvent.PROGRESS, null, null, event.urlLoader.bytesLoaded, event.urlLoader.bytesTotal);
        newEvent.currentTarget = this;
        this.dispatchEvent(newEvent);
    };
    URLLoader.prototype.completeCallback = function (event) {
        if (event === void 0) { event = null; }
        var newEvent = new Event(Event.COMPLETE);
        newEvent.currentTarget = this;
        this.dispatchEvent(newEvent);
    };
    URLLoader.prototype.load = function (request) {
        this._adaptee.load(request);
    };
    ;
    return URLLoader;
}(EventDispatcher));
export { URLLoader };
